// Extracts keyword matches from highlighted HTML, merging adjacent <em> tags
// separated only by whitespace (e.g. phrase keywords like "HM Treasury").
const extractMergedKeywordMatches = (htmlSnippet) => {
  if (!htmlSnippet) {
    return [];
  }

  const container = document.createElement('div');
  container.innerHTML = htmlSnippet;

  const results = [];
  const elements = container.querySelectorAll('em.policymogul-keyword-match');

  elements.forEach((element) => {
    if (!container.contains(element)) {
      return;
    }

    let text = element.textContent;
    let node = element.nextSibling;

    while (node) {
      if (node.nodeType === 3) {
        if (node.textContent.trim() === '') {
          text += node.textContent;
          const next = node.nextSibling;
          node.remove();
          node = next;
          continue;
        }
        break;
      }
      if (node.nodeType === 1 && node.matches?.('em.policymogul-keyword-match')) {
        text += node.textContent;
        const next = node.nextSibling;
        node.remove();
        node = next;
        continue;
      }
      break;
    }

    results.push(text);
  });

  return Array.from(new Set(results));
};

export default extractMergedKeywordMatches;
